import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

import SearchFormFunctionalityHOC from './components/searchFormWrapper';
import RJRDatePicker from '../../components/shared/rjrDatePicker';
import SearchFormHeader from './components/searchFormHeader';
import SearchFormLabel from './components/searchFormLabel';
import SearchFormButtons from './components/searchFormButtons/searchFormButtons';
import SearchFormTextInput from './components/searchFormInput';
import SearchFormGroup from './components/searchFormGroup';


class SearchFormLorillard extends Component {
    render() {
        return (
            <div> 
                <SearchFormHeader headerTitle="Lorillard" formType={this.props.formType} /> 
                <Form>
                    { (this.props.formType === '4B' || this.props.formType === '4b') &&
                        <div>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Depository Box"  />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="depositoryBoxNumber" formData={this.props.formData} /> 
                            </SearchFormGroup>

                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Depository Production Date" />
                                <RJRDatePicker changeHandler={this.props.dateFieldHandler} name="depositoryProductionDate" id="depositoryProductionDate" formData={this.props.formData} />
                            </SearchFormGroup>
                        </div>
                    }

                    { (this.props.formType === 'public')  &&
                        
                        <SearchFormGroup>
                            <SearchFormLabel clickHandler={this.props.modalHandler} title="Combined Text" />
                            <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="combinedText" formData={this.props.formData} /> 
                        </SearchFormGroup>                
                    }

                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Document ID Begin" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="documentIdBegin" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Document ID End" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="documentIdEnd" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Title" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="title" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Document Date" />
                        <RJRDatePicker changeHandler={this.props.dateFieldHandler} name="documentDate" id="documentDate" formData={this.props.formData} />
                    </SearchFormGroup>

                    { (this.props.formType === 'public' || this.props.formType === 'privilege') && 
                        <div>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Document Date Qualifier" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} name="documentDateQualifier" id="documentDateQualifier" formData={this.props.formData} />
                            </SearchFormGroup>                           
                        </div>

                    }

                    { (this.props.formType === '4B' || this.props.formType === '4b') &&
                        <SearchFormGroup>
                            <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Author" />
                            <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="author" formData={this.props.formData} /> 
                        </SearchFormGroup>      
                    }   

                    { (this.props.formType === 'public' || this.props.formType === 'privilege' || this.props.formType === 'confidential') && 
                        <SearchFormGroup>
                            <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Author" />
                            <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="personAuthor" formData={this.props.formData} /> 
                        </SearchFormGroup>   
                    }

                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Organization Author" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="organizationAuthor" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    { (this.props.formType === 'privilege')  &&                   
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Author" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="author" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    }          

                    { (this.props.formType === '4B' || this.props.formType === '4b') &&
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Addressee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="addressee" formData={this.props.formData} /> 
                    </SearchFormGroup>         
                    }   
                    
                    { (this.props.formType === 'public' || this.props.formType === 'privilege' || this.props.formType === 'confidentiallity') && 
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Addressee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="personAddressee" formData={this.props.formData} /> 
                    </SearchFormGroup>    
                    }

                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Organization Addressee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="organizationAddressee" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    { (this.props.formType === 'privilege')  &&                   
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Addressee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="addressee" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    }

                    { (this.props.formType === '4B' || this.props.formType === '4b') &&
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Copyee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="copyee2" formData={this.props.formData} /> 
                    </SearchFormGroup>          
                    }   
                    
                    { (this.props.formType === 'public' || this.props.formType === 'privilege' || this.props.formType === 'confidentiallity') && 
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Copyee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="personCopyee" formData={this.props.formData} /> 
                    </SearchFormGroup>   
                    }

                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Organization Copyee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="organizationCopyee" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    { (this.props.formType === 'privilege')  &&                   
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Copyee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="copyee2" formData={this.props.formData} /> 
                    </SearchFormGroup>         
                    }           
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Attachment Begin" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="attachmentBegin" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Attachment End" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="attachmentEnd" formData={this.props.formData} /> 
                    </SearchFormGroup>                                                          
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Document Type" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="documentType" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Case Name/Case Identifier" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="caseName" formData={this.props.formData} /> 
                    </SearchFormGroup>                    

                    { (this.props.formType === 'privilege')  &&
                        <div>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Depository Box"  />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="depositoryBox" formData={this.props.formData} /> 
                            </SearchFormGroup>

                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Depository Production Date" />
                                <RJRDatePicker changeHandler={this.props.dateFieldHandler} name="depositoryProductionDate" id="depositoryProductionDate" formData={this.props.formData} />
                            </SearchFormGroup>
                        </div>
                    }

                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Request Number" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="requestNumber" formData={this.props.formData} /> 
                    </SearchFormGroup>

                    {/* the following form fields are only for public forms */}
                    { (this.props.formType === 'public')  &&
                            <div>                
                                <SearchFormGroup>
                                    <SearchFormLabel clickHandler={this.props.modalHandler} title="Other Document Type" />
                                    <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="otherDocumentType" formData={this.props.formData} /> 
                                </SearchFormGroup>                                                                                                   
                            </div> 
                        }

                        {/* the following form fields are only for privileged forms */}

                        { (this.props.formType === 'privilege')  &&
                            <div>
                                <SearchFormGroup>
                                    <SearchFormLabel clickHandler={this.props.modalHandler} title="Privilege" />
                                    <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="privilege" formData={this.props.formData} /> 
                                </SearchFormGroup>
                                <SearchFormGroup>
                                    <SearchFormLabel clickHandler={this.props.modalHandler} title="Privilege Abstract" />
                                    <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="privilegeAbstract" formData={this.props.formData} /> 
                                </SearchFormGroup>
                                <SearchFormGroup>
                                    <SearchFormLabel clickHandler={this.props.modalHandler} title="Adverse Ruling" />
                                    <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="adverseRuling" formData={this.props.formData} /> 
                                </SearchFormGroup>
                                <SearchFormGroup>
                                    <SearchFormLabel clickHandler={this.props.modalHandler} title="Court Action Numbers" />
                                    <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="courtActionNumber" formData={this.props.formData} /> 
                                </SearchFormGroup>
                            </div>
                        }

                        <SearchFormButtons searchHandler={this.props.searchHandler} clearHandler={this.props.clearFormHandler} />

                </Form>               
            </div>
        );
    }
}

export default SearchFormFunctionalityHOC((props) => ({
    
}), SearchFormLorillard);


// WEBPACK FOOTER //
// ./src/components/searchForm/searchForm_lorillard.js